import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { remember } from '@utils/returnTo';

interface IRememberingRedirectProps {
  to: string;
}

const RememberingRedirect: React.FC<IRememberingRedirectProps> = ({ to }) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    remember(pathname + search);
  }, [pathname, search]);

  return <Navigate to={to} replace />;
};

export default RememberingRedirect;
